module.exports = __webpack_public_path__ + "static/sport/out6.bfff31e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/out6.png
// module id = FKmz
// module chunks = 0